<template>
  <vbt-content-box
    :loading-error="loadingError"
    :loading="isLoading"
    title="Statistics"
  >
    <template #toolbar>
      <v-flex lg3>
        <vbt-date-picker
          v-model="dates"
          :clearable="false"
          range
        />
      </v-flex>
    </template>
    <v-layout column>
      <kernel-order-statuses-chart :loading="isLoading" />
      <kernel-order-validation-statuses-chart :loading="isLoading" />
    </v-layout>
  </vbt-content-box>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import { useDataLoading, useErrorBoundary } from '@mixins/factories';

import { getDatesRangeByLastDays } from '@helpers';

import { namespace as LocationsNamespace } from '@store/modules/locations.types';

import { namespace as DashboardNamespace, ActionTypes as DashboardActionTypes } from '../store.types';

import KernelOrderStatusesChart from '../_components/KernelOrderStatusesChart.vue';
import KernelOrderValidationStatusesChart from '../_components/KernelOrderValidationStatusesChart.vue';

const dataLoadingOptions = { getterName: 'getStats', searchable: false, paged: false };

export default {
  name: 'KernelDashboard',
  components: {
    KernelOrderStatusesChart,
    KernelOrderValidationStatusesChart,
  },
  mixins: [
    useDataLoading(dataLoadingOptions),
    useErrorBoundary(),
  ],
  data: () => ({ dates: getDatesRangeByLastDays(7) }),
  computed: {
    ...mapState(LocationsNamespace, ['suffix']),
  },
  watch: {
    dates: {
      handler(dates) {
        this.getStats({ dates });
      },
      deep: true,
    },
    suffix: '$_refreshData',
  },
  methods: {
    ...mapActions(DashboardNamespace, {
      async getStats(dispatch, { dates = this.dates } = {}) {
        try {
          await dispatch(DashboardActionTypes.GET_STATS, {
            start: dates[0],
            end: `${dates[1]} 23:59:59`,
          });
        } catch (e) {
          this.setLoadingError(e);
        }
      },
    }),
  },
};
</script>
